"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createLampElement_1 = __importDefault(require("./createLampElement"));
const caunter_1 = __importDefault(require("./caunter"));
//= addLamps 
const addLamps = (currentArrLamps, elementsOnPage) => {
    //console.log('addLamps >>> ', currentArrLamps);
    let start = (0, caunter_1.default)('plus-one') * elementsOnPage;
    let finish = start + elementsOnPage;
    (0, createLampElement_1.default)(currentArrLamps, start, finish);
};
exports.default = addLamps;
